export interface LandCost {
    id: number;
    appraisal_basic_id: number;
    purchase_price: number;
    fees: number;
    stamp_duty: number;
    lawyer_fees: number;
}

// to single object maping
export const mapLandCost = (data:any): LandCost => {
    if(!data){
        throw new Error('Invalid Data')
    }
    const  res: LandCost ={
        id: data.id,
        appraisal_basic_id: data.appraisal_basic_id,
        purchase_price: data.purchase_price,
        fees: data.fees,
        stamp_duty: data.stamp_duty,
        lawyer_fees: data.lawyer_fees,
    }
    return res;
}

// maping list objects
export const mapLandCosts = (data:any[]): LandCost[] => {
     if (!Array.isArray(data)) {
       throw new Error('Invalid Data');
     }
     return data.map(mapLandCost);
}